import React, { FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useIdentity } from 'src/core/services/authentication';
import { setHeader, setRoutes } from 'src/core/ui/shell';
import { AppConfig } from 'src/inversify.config';
import { AppConfiguration } from 'src/core/services/configuration.service';
import { Tabs } from 'antd';

const HangfireDashboard: FC = () => {
  const identity = useIdentity();
  const config: AppConfiguration = useContext(AppConfig);
  const { t } = useTranslation();

  if (identity.email !== 'admin@tempuri.org' && identity.email !== 'melissa.alonso@sptab.com') return <></>;
  setHeader(t('HangfireDashboard'));

  setRoutes([
    { path: '', breadcrumbName: t('Home') },
    { path: '', breadcrumbName: t('HangfireDashboard') },
  ]);

  return (
    <Tabs
      items={[
        {
          key: 'export-import',
          label: t('ImportExport'),
          children: (
            <iframe
              style={{ width: '100%', height: '100vh', border: '0px' }}
              src={`${config.exportImportUrl}/export-import/api/hangfire?access_token=${identity.accessToken}`}
              title="Hangfire Dashboard"
            />
          ),
        },
        {
          key: 'licensing',
          label: t('Licenses'),
          children: (
            <iframe
              style={{ width: '100%', height: '100vh', border: '0px' }}
              src={`${config.serviceUrl}/api/hangfire?access_token=${identity.accessToken}`}
              title="Hangfire Dashboard"
            />
          ),
        },
      ]}
    ></Tabs>
  );
};

export default HangfireDashboard;
